<template>
  <div class="content if-profile manual_input report-tab">
    <div class="md-layout ratios-report">
      <SPIFReportHeader :headerData="this.headerData" />

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0"
      >
        <div class="manege-input-popap">
          <!-- <md-dialog :md-active.sync="showDialog">
            <p>
              <b
                >Net Working Capital (Current Assets-Current
                Liabilities)/Business Revenue.</b
              >
              Indicates if a company is maintaining a reasonable level of
              liquidity relative to its Business Revenue volume. Higher is
              generally better, but very high ratios may indicate an overly
              conservative reliance on liquid assets, while low ratios suggest
              the opposite. Your score suggests that the business should
              undertake a significant review of liquidity practices.
            </p>
          </md-dialog> -->
          <!-- <md-card-header class="md-card-header-icon messages-box">
            <div class="card-icon md-ripple" @click="showDialog = true">
              <md-icon class="icon-arrow">double_arrow</md-icon>
              <md-icon>help</md-icon>
            </div>
          </md-card-header> -->
        </div>
        <div class="md-toolbar-row">
          <nav-tabs-card>
            <template slot="content">
              <!-- <md-card-header class="md-card-header-icon manag-title">
                <h1 class="md-headline text-left">
                  Manage Inputs
                </h1>
              </md-card-header> -->
              <h1 class="section_header m-0 p-0">Manage Inputs</h1>
              <div class="md-layout-item md-size-100 p-0">
                <md-card class="if_card">
                  <md-card-header class="md-card-header-icon">
                    Data Input Upload
                  </md-card-header>
                  <md-card-content>
                    <div class="extra_space">
                      <div class="md-layout">
                        <div
                          class=" md-layout-item md-medium-size-100 md-size-100 p-0"
                        >
                          <!-- <h3>Data Input Upload</h3> -->
                          <ul>
                            <li>
                              Download the Bizminer Industry Financial Input
                              5-year Templateand save it offline as a CSV file.
                            </li>
                            <li>Populate the template offline</li>
                            <li>
                              Select the Choose File or Browse button to find
                              the populated CSV file on your device.
                            </li>
                            <li>
                              Use the Upload Inputs button to complete the
                              process.
                            </li>
                            <li>
                              Generate the report. Your financials will be
                              integrated; percentages, summary line items and
                              ratios will auto-calculate.
                            </li>
                          </ul>
                        </div>
                        <div class="md-layout-item p-0">
                          <div class="choose-files-box">
                            <md-field class="choose-file">
                              <label>Choose File</label>
                              <md-file v-model="single" accept="image/*" />
                            </md-field>
                            <p>No Choose file</p>
                          </div>
                        </div>
                      </div>
                      <div class="md-layout">
                        <div class="md-layout-item p-0">
                          <div class="choose-files-box">
                            <md-field class="choose-file upload-file">
                              <label>Upload File</label>
                              <md-file v-model="single" accept="image/*" />
                            </md-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
              <div class="md-layout">
                <div
                  class="md-layout-item md-medium-size-100 md-size-100 md-large-size-100 py-4"
                >
                  <h1 class="section_header p-0 my-2">Manual Input</h1>
                  <h5 class="m-0">
                    <strong
                      >*Please do not use periods, dollar signs, or character,
                      Commas are auromatically added.</strong
                    >
                  </h5>
                  <h5 class="m-0">
                    <strong>
                      *Business Revenue and Gross Margin are required fields
                    </strong>
                  </h5>
                </div>
                <div
                  class="md-layout-item md-medium-size-100 md-size-100 md-large-size-100 p-0 mt-2"
                >
                  <md-tabs md-alignment="left">
                    <md-tab
                      v-for="input in inputFields"
                      :id="input.title"
                      :key="input.title"
                      :md-label="input.title"
                      md-icon="arrow_drop_down"
                      class="p-0"
                    >
                      <div class="md-layout">
                        <div class="md-layout-item p-0">
                          <md-card-header>
                            {{ input.title }}
                          </md-card-header>
                          <md-card-content>
                            <md-table class="profit-and-loss-table">
                              <md-table-row>
                                <md-table-head
                                  :class="{
                                    'md-table-black-side-label':
                                      input.type !== 'BlueYears',
                                    'md-table-side-label':
                                      input.type === 'BlueYears',
                                  }"
                                  >{{ input.title }}
                                </md-table-head>
                                <md-table-head
                                  v-for="(key, index) in years"
                                  :key="key"
                                  :class="{
                                    grey:
                                      !showYears[index] &&
                                      input.type === 'BlueYears',
                                  }"
                                  class="md-table-side-label"
                                  >{{ input.type === "BlueYears" ? key : "" }}
                                </md-table-head>
                                <!-- <md-table-head></md-table-head> -->
                              </md-table-row>

                              <md-table-row
                                v-for="field in input.data"
                                :key="field"
                              >
                                <md-table-cell :md-label="input.title"
                                  >{{ inputTitles ? inputTitles[field] : "" }}
                                </md-table-cell>

                                <md-table-cell
                                  v-for="(each, index) in valuesArr"
                                  :key="index"
                                >
                                  <input
                                    :id="inputTitles ? field + '_' + index : ''"
                                    v-model="each[inputTitles ? field : '']"
                                    @input="
                                      (e) =>
                                        handleInput(
                                          e,
                                          inputTitles ? field : '',
                                          index
                                        )
                                    "
                                  />
                                </md-table-cell>
                              </md-table-row>
                            </md-table>
                          </md-card-content>
                        </div>
                      </div>
                      <div class="md-layout-item md-size-100 p-0 btn_wpr">
                        <button
                          type="button"
                          @click="saveReport('clear')"
                          class="md-button md-info md-theme-default button-inputs"
                        >
                          <div class="md-ripple">
                            <div class="md-button-content">
                              Clear Inputs
                            </div>
                          </div>
                        </button>
                        <button
                          type="button"
                          v-if="!isSample"
                          @click="saveReport()"
                          class="md-button md-info md-theme-default"
                        >
                          <div class="md-ripple">
                            <div class="md-button-content">
                              Submit Manual Inputs
                            </div>
                          </div>
                        </button>
                      </div>
                    </md-tab>
                  </md-tabs>
                </div>
              </div>
            </template>
          </nav-tabs-card>
        </div>
      </div>
      ''
    </div>
  </div>
</template>

<script>
import { NavTabsCard } from "@/components";
import { mapActions, mapState } from "vuex";
import SPIFReportHeader from "./_partials/SPIFHeader.vue";

export default {
  components: {
    SPIFReportHeader,
    NavTabsCard,
  },
  props: ["headerData"],
  data() {
    return {
      showDialog: false,
      single: null,
      params: {},
    };
  },

  computed: {
    ...mapState({
      inputFields: (state) =>
        state.user.report.data.inputFields.filter((element) => {
          if (element && element.data && element.data.length > 0)
            return element;
        }),
      inputData: (state) =>
        Object.values(state.user.report.data.inputData).map((element) => {
          return element;
        }),
      data: (state) => {
        return state.user.report.data.data.data;
      },
      inputTitles: (state) => state.user.report.data.inputTitles,
      showYears: (state) => state.user.report.data.showYears,
      years: (state) =>
        state.user.report.data.years.filter((element) => {
          if (state.user.report.data.showYears[element]) return element;
        }),
      showYearsArray: (state) =>
        Object.values(state.user.report.data.showYears).map((element) => {
          return element;
        }),
      showYearsArray: (state) =>
        Object.keys(state.user.report.data.showYears).filter((element) => {
          if (state.user.report.data.showYears[element]) return element;
        }),
    }),
    valuesArr() {
      // return this.inputData.length !== 0 ? this.inputData : this.inputFields.map(i => i.data.reduce((acc, cur, i) => ({...acc, [cur]: null }), {}))
      return this.showYearsArray.map((val, index) => {
        if (this.showYears[val]) {
          let data = this.inputData[index];
          return {
            //...val.data.reduce((acc, cur) => ({ ...acc, [cur]: null }), {}),
            ...data,
            year: val,
          };
        }
        /*else{
          let auxObj = {};
          Object.keys(this.inputData[0]).forEach(element=>{
             return auxObj[element]= 0;
              
          });

          return {
            ...auxObj,
            year: val,
          }
        }*/
      });
    },
    isSample() {
      return this.$route.path.indexOf("sample") > -1;
    },
  },
  methods: {
    ...mapActions({
      save: "user/saveReport",
      getReport: "user/getReport",
      alertSuccess: "alerts/success",
      alertError: "alerts/error",
      updatePullTime: "tracking/updatePullTime",
    }),
    handleInput(e, key, index) {
      this.params[key + "_field_" + index] = Number(e.target.value);
    },
    saveReport(action = "save") {
      this.loading = true;
      let params = {};

      if (action === "save") {
        let currentData = this.valuesArr.reduce(
          (acc, item, index) => ({
            ...acc,
            ...Object.entries(_.omit(item, ["ID", "inputID"])).reduce(
              (acc, [key, val]) => ({
                ...acc,
                [key + "_field_" + index]: val,
              }),
              {}
            ),
          }),
          {}
        );

        let checkedYears = this.showYearsArray.reduce((acc, v, i) => {
          if (v) return { ...acc, [`year_${i}_check`]: v };
          else return { ...acc };
        }, {});
        this.valuesArr.forEach(function(item, index, array) {
          let v = document.getElementById("other_netSales_" + index);
          if (
            (!item["other_netSales"] && item["year"] !== "2017") ||
            (parseInt(item["other_netSales"]) <= 0 && item["year"] !== "2017")
          ) {
            if (v) {
              v.classList.add("error-input");
            }
          } else {
            if (v.classList.contains("error-input")) {
              v.classList.remove("error-input");
            }
          }
          let c = document.getElementById("other_grossProfit_" + index);
          if (c) {
            if (
              (!item["other_grossProfit"] && item["year"] !== "2017") ||
              (parseInt(item["other_grossProfit"]) <= 0 &&
                item["year"] !== "2017")
            ) {
              if (c) {
                c.classList.add("error-input");
              }
            } else {
              if (c.classList.contains("error-input")) {
                c.classList.remove("error-input");
              }
            }
          }
        });

        params.data = {
          ...currentData,
          ...this.params,
          ...checkedYears,
        };
        // params.data = Object.keys( params.data).map(i => Number(params.data[i]))
        params.data = _.omitBy(params.data, _.isNil);
      }
      if (action === "remove") {
      }

      this.save({
        report_id: this.$route.params.id,
        profile_id: this.$route.params.id,
        type: "if",
        action: action,
        ...params,
      })
        .then((res) => {
          this.alertSuccess("Data loaded.");

          this.$router.push({
            name: "SPIFAboutTheData",
            params: this.$route.params.id,
          });
          this.$router.go();
        })
        .catch((err) => {
          this.alertError("An error occurred. We have been notified.");
        })
        .finally(() => {
          this.loading = false;
          this.updatePullTime({
            isFinishedDate: true,
            productId: this.$route.params.id,
          });
        });
    },
  },
};
</script>

<style lang="scss">
.ratios-report {
  .grey {
    /*background-color: black;*/
    /*opacity: 0.5;*/
    background-color: #c1c1c1;
  }

  .md-table-black-side-label {
    .md-table-head-label {
      color: black !important;
    }
  }

  .md-table-side-label {
    .md-table-head-label {
      color: #3b7ef1 !important;
    }
  }

  .financal-report-col-1 {
    display: flex;
    align-items: center;
  }

  .financal-report-col-2 {
    .access-button {
      margin-top: 18px !important;
    }

    .financal-report-col-3 {
      display: flex;
      justify-content: flex-end;
    }
  }

  .heder-titel-col-2 {
    margin-bottom: 35px;
  }

  .summary-scores-box-star {
    .md-button-content {
      .md-icon {
        color: #3b7ef1;
      }
    }

    h4 {
      margin-left: 60px;
    }
  }

  .summary-scores-box-flag {
    .md-icon {
      color: #3b7ef1;
    }

    .w-100 {
      width: 100%;
    }
  }

  .choose-files-box {
    display: flex;
    align-items: center;
    margin-bottom: 25px;

    p {
      margin: 0;
      margin-left: 10px;
    }

    .md-icon {
      display: none !important;
    }

    .choose-file {
      background-color: #e3e4e5;
      width: 120px;
      border-radius: 3px;
      padding: 0;
      margin: 0;

      label {
        margin-right: 11px;
        position: absolute;
        left: 24px;
        top: 11px;
      }

      input {
        margin: 0;
      }
    }

    .upload-file {
      background-color: #3b7ef1;

      label {
        color: white;
        top: 11px;
      }
    }

    .md-field:not(.md-disabled):after {
      background-color: transparent;
    }
  }

  .icon-arrow {
    transform: rotate(180deg) !important;
  }

  .md-table-cell {
    // width: 100%;

    .md-table-cell-container {
      input {
        background-color: transparent !important;
        border: 1px solid #ddd;
        width: 60px;

        &.error-input {
          background-color: #ffbbbb !important;
        }
      }
    }
  }

  .md-collapse-content {
    padding: 0 !important;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }

  .manag-title {
    h1 {
      margin: 0;
    }
  }

  .manege-input-popap {
    display: flex;
    justify-content: flex-end;
  }
}

.button-inputs {
  margin-right: 10px !important;
}
</style>
